import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Lesson from "./pages/Lesson";
import Schedule from "./pages/Schedule";
import Progress from "./pages/Progress";
import Subscription from "./pages/Subscription";
import Owner from "./pages/Owner";
import ProfessionalDevelopment from "./pages/ProfessionalDevelopment";
import PDCourse from "./pages/PDCourse";
import PDSuccess from "./pages/PDSuccess";
import PageTracker from "./components/PageTracker";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  return children;
}

function PublicHome() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <ProfessionalDevelopment />;
}

function HomeschoolHome() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageTracker />
          <Navbar />
          <Routes>
            <Route path="/" element={<PublicHome />} />
            <Route path="/homeschool" element={<HomeschoolHome />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/professional-development" element={<Navigate to="/" replace />} />
            <Route path="/pd/course" element={<PDCourse />} />
            <Route path="/pd/success" element={<PDSuccess />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/lesson/:id" element={<Protected><Lesson /></Protected>} />
            <Route path="/schedule" element={<Protected><Schedule /></Protected>} />
            <Route path="/progress" element={<Protected><Progress /></Protected>} />
            <Route path="/owner" element={<Protected><Owner /></Protected>} />
            <Route path="/subscription/success" element={<Protected><Subscription mode="success"/></Protected>} />
            <Route path="/subscription/cancel" element={<Protected><Subscription mode="cancel"/></Protected>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
